const Font = () => {
  return (
    <style jsx global>{`
      @font-face {
        font-family: "Roboto";
        src: url("/fonts/Roboto/roboto-regular.ttf");
      }
      @font-face {
        font-family: "Roboto-Bold";
        src: url("/fonts/Roboto/Roboto-Bold.ttf");
      }
      @font-face {
        font-family: "Campton-bold";
        src: url("/fonts/Campton/Campton-Bold.ttf");
      }
      @font-face {
        font-family: "Campton-light";
        src: url("/fonts/Campton/Campton-Light.otf");
      }
    `}</style>
  );
};

export default Font;
